'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var actionTypes = {
    FETCH_MODELS_REQUEST: 'FETCH_MODELS_REQUEST',
    FETCH_MODELS_SUCCEEDED: 'FETCH_MODELS_SUCCEEDED',
    FETCH_MODELS_FAILED: 'FETCH_MODELS_FAILED',
    FETCH_MODEL_REQUEST: 'FETCH_MODEL_REQUEST',
    FETCH_MODEL_SUCCEEDED: 'FETCH_MODEL_SUCCEEDED',
    FETCH_MODEL_FAILED: 'FETCH_MODEL_FAILED',
    EDIT_MODEL_REQUEST: 'EDIT_MODEL_REQUEST',
    EDIT_MODEL_SUCCEEDED: 'EDIT_MODEL_SUCCEEDED',
    EDIT_MODEL_FAILED: 'EDIT_MODEL_FAILED',
    EDIT_MODEL_CANCELED: 'EDIT_MODEL_CANCELED',
    CHANGE_FILTER: 'CHANGE_FILTER',
    APPLY_FILTER_ERROR: 'APPLY_FILTER_ERROR',
    CLEAR_MODELS_FILTER: 'CLEAR_MODELS_FILTER'
};

function fetchModelsRequest(filter) {
    return {
        type: actionTypes.FETCH_MODELS_REQUEST,
        filter: filter
    };
}

function fetchModelsSucceeded(models, filter) {
    return {
        type: actionTypes.FETCH_MODELS_SUCCEEDED,
        models: models,
        filter: filter
    };
}

function fetchModelsFailed(message) {
    return {
        type: actionTypes.FETCH_MODELS_FAILED,
        message: message
    };
}

function fetchModelRequest(modelId) {
    return {
        type: actionTypes.FETCH_MODEL_REQUEST,
        modelId: modelId
    };
}

function fetchModelSucceeded(model) {
    return {
        type: actionTypes.FETCH_MODEL_SUCCEEDED,
        model: model
    };
}

function fetchModelFailed() {
    return {
        type: actionTypes.FETCH_MODEL_FAILED
    };
}

function editModelRequest(modelId, model, redirect) {
    return {
        type: actionTypes.EDIT_MODEL_REQUEST,
        modelId: modelId,
        model: model,
        redirect: redirect
    };
}

function editModelSucceeded() {
    return {
        type: actionTypes.EDIT_MODEL_SUCCEEDED
    };
}

function editModelFailed() {
    return {
        type: actionTypes.EDIT_MODEL_FAILED
    };
}

function editModelCanceled() {
    return {
        type: actionTypes.EDIT_MODEL_CANCELED
    };
}

function changeFilter(key, value) {
    return {
        type: actionTypes.CHANGE_FILTER,
        key: key,
        value: value
    };
}

function clearModelsFilter() {
    return {
        type: actionTypes.CLEAR_MODELS_FILTER
    };
}

var actionCreators = {
    fetchModelsRequest: fetchModelsRequest,
    fetchModelsSucceeded: fetchModelsSucceeded,
    fetchModelsFailed: fetchModelsFailed,
    fetchModelRequest: fetchModelRequest,
    fetchModelSucceeded: fetchModelSucceeded,
    fetchModelFailed: fetchModelFailed,
    editModelRequest: editModelRequest,
    editModelSucceeded: editModelSucceeded,
    editModelFailed: editModelFailed,
    editModelCanceled: editModelCanceled,
    changeFilter: changeFilter,
    clearModelsFilter: clearModelsFilter
};

exports.actionTypes = actionTypes;
exports.actionCreators = actionCreators;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/actions/models.js
// module id = 268
// module chunks = 0